<script>
    export let fill = 'red'
</script>

<style>
    svg#event-selector {
        position: absolute;
        top: 182px;
        left: 40px;
        width: 125.19px;
        height: 31.42px;
    }

    .cls-1 {
        stroke: #fff;
        stroke-miterlimit: 10;
        stroke-width: 0.3px;
    }
</style>

<svg id="event-selector" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 125.19 31.42">
    <g id="Layer_2" data-name="Layer 2">
        <g {fill} id="Layer_1-2" data-name="Layer 1">
            <rect class="cls-1" x="0.15" y="0.15" width="124.89" height="31.12" rx="15.43" />
        </g>
    </g>
</svg>
